/* NB-017-AB */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.showdown-vs-hero--var-1');
  if (!root) return;

  const cta = root.querySelector('[data-nb017-cta]');
  if (!cta) return;

  cta.addEventListener('click', () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'nb017_cta_click',
      cta_location: 'hero',
      task_id: 'NB-017-AB',
    });
  });
});
